import { render } from "./SlideManagement.vue?vue&type=template&id=4710f0d8&scoped=true"
import script from "./SlideManagement.vue?vue&type=script&lang=js"
export * from "./SlideManagement.vue?vue&type=script&lang=js"

import "./SlideManagement.vue?vue&type=style&index=0&id=4710f0d8&scoped=true&lang=css"

import exportComponent from "D:\\newProjectGit\\HbzsbAdminClient\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4710f0d8"]])

export default __exports__